import { DineoutCartState } from "@swiggy-private/checkout-types";

export enum DineoutCartActionTypes {
    UPDATE_LOCAL_AND_REVIEWED_CART,
    UPDATE_LOCAL_CART,
    UPDATE_REVIEWED_CART,
    UPDATE_CART,
    CLEAR_LOCAL_AND_REVIEWED_CART,
    REMOVE_CART_ITEM,
    UPDATE_ERROR_PAYLOAD,
    // TODO: need to add the action type for the error payload
}

export type DineoutCartAction =
    | {
          type: DineoutCartActionTypes.UPDATE_LOCAL_AND_REVIEWED_CART;
          payload: {
              localCart: DineoutCartState["localCart"];
              reviewedCart: DineoutCartState["reviewedCart"];
          };
      }
    | { type: DineoutCartActionTypes.UPDATE_LOCAL_CART; payload: DineoutCartState["localCart"] }
    | { type: DineoutCartActionTypes.UPDATE_REVIEWED_CART; payload: DineoutCartState["reviewedCart"] }
    | { type: DineoutCartActionTypes.CLEAR_LOCAL_AND_REVIEWED_CART; payload: { itemId: string; quantity: number } };

export const DineoutCartReducer = (state: DineoutCartState, action: DineoutCartAction): DineoutCartState => {
    switch (action.type) {
        case DineoutCartActionTypes.UPDATE_LOCAL_AND_REVIEWED_CART:
            return {
                ...state,
                localCart: action.payload.localCart,
                reviewedCart: action.payload.reviewedCart,
            };

        case DineoutCartActionTypes.UPDATE_LOCAL_CART:
            return {
                ...state,
                localCart: action.payload,
            };

        case DineoutCartActionTypes.UPDATE_REVIEWED_CART:
            return {
                ...state,
                reviewedCart: action.payload,
            };

        case DineoutCartActionTypes.CLEAR_LOCAL_AND_REVIEWED_CART:
            return {
                ...state,
                localCart: null,
                reviewedCart: null,
            };

        default:
            return state;
    }
};
